import { combineReducers } from 'redux';
import inbox, { crossInboxReducer } from '../components/menuInbox/ducks';
import table, { crossTableReducer } from '../components/leadTable/ducks';
import filterTable, { crossFilterTableReducer } from '../components/filterTable/ducks';
import filterStatus from '../components/filterStatus/ducks';
import publisherChat from '../components/contacto/chat/ducks';
import seekerChat from '../components/seeker/ducks';
import seekerLeads from '../components/seeker/messages/SeekerLeads/ducks';
import seekerInfo from '../components/seeker/message/infoLeads/ducks';
import postingFiltered, { crossPostingFilteredReducer } from '../components/postingFiltered/ducks';
import infoLead from '../components/contacto/infoLead/ducks';

const combinedReducers = combineReducers({
  inbox,
  table,
  filterTable,
  filterStatus,
  postingFiltered,
  infoLead,
  publisherChat,
  seekerChat,
  seekerInfo,
  seekerLeads
});

export default (state, action) => {
  const intermediateState = combinedReducers(state, action);
  const partialState = crossInboxReducer(intermediateState, action);
  const partialState1 = crossTableReducer(partialState, action);
  const partialState2 = crossFilterTableReducer(partialState1, action);
  const finalState = crossPostingFilteredReducer(partialState2, action);
  return finalState;
};
